import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/header";
import Layout from "../../components/layout";
import Drawer from "../../components/Drawer";
import Button from "../../components/elements/button";
import toast from "react-hot-toast";
import { URLS } from "../../_config";
import { useLocation, useParams } from "react-router-dom";
import GeneralWOdetails from "./_components/generalWOdetails";
import AttachmentWOdetails from "./_components/attachmentWOdetails";
import CompletionrecordWOdetails from "./_components/completionrecordWOdetails";
import ImpactedassetsWOdetails from "./_components/impactedassetsWOdetails";
import PartlistWOdetails from "./_components/partslistWOdetails";
import TasksWOdetails from "./_components/tasksWOdetails";
import Loader from '../../components/loader';
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { Dropdown, Menu } from "../../components/Dropdown";
import Icon from "../../components/icons";
import { useWorkOrderApi } from "../../store/api/hooks/workOrderApiHook";
import moment from "moment";
import ScheduleModalWorkOrder from "./_components/schedulepopupWorkOrder";
import CreateWorkOrder from "./_components/createWorkOrder";
import ClockElapseTimer from "../../components/clockTimer";
import { getPermissionInfo } from "../../_common/functions";
import { useUserSelector } from "../../store/selectors/userSelector";
ModuleRegistry.registerModules([AllCommunityModule]);

const WorkOrderDetails: React.FC = () => {
  const loggedinuser: any = useUserSelector();
  const location = useLocation();
  const addNewAssetRef: any = React.createRef<HTMLButtonElement>();
  const workOrderAPI: any = useWorkOrderApi();
  const params: any = useParams();
  const createSchedulerModalRef: any = useRef();
  const [tab, setTab] = useState("general");

  const [showloader, setShowloader] = useState<boolean>(true);
  const [wodata, setWodata] = useState<any>(null);
  const [noWoFound, setNoWoFound] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>(null);
  const getWorkOrderDetails = async (id: string) => {
    const payload = { WorkOrderID: id };

    const wodata = await new Promise((resolve, reject) => {
      workOrderAPI.GetWorkOrderByID(payload, (resp: any) => {
        if (resp.startDate) {
          resp[`bind_startDate`] = moment.utc(resp.startDate).local().format("MM/DD/YY hh:mm a");
        }
        if (resp.endDate) {
          resp[`bind_endDate`] = moment.utc(resp.endDate).local().format("MM/DD/YY hh:mm a");
        }
        if (resp.originalStartDate) {
          resp[`bind_originalStartDate`] = moment.utc(resp.originalStartDate).local().format("MM/DD/YY hh:mm a");
        }
        if (resp.originalEndDate) {
          resp[`bind_originalEndDate`] = moment.utc(resp.originalEndDate).local().format("MM/DD/YY hh:mm a");
        }
        resolve(resp);
      }, (error: any) => {
        toast.error(error);
        reject(error);
      })
    }).catch((error: any) => {
      return null;
    });
    setShowloader(false);
    if (wodata && wodata.hasOwnProperty("workOrderID")) {
      setWodata(wodata);
    } else {
      setNoWoFound(true);
      toast.error("Task not found");
    }

    // Simulate an API call to fetch Task details
    console.log(`Fetching details for Task ID: ${id}`, wodata);
  };

  useEffect(() => {
    if (params.id) {
      console.log("WO Details", params.id);
      getWorkOrderDetails(params.id);
      //getAssetsList(params.id);
    }
  }, [params]);
  const createDrawerRef: any = useRef();
  const createFacilityRef: any = useRef();
  return (
    <Layout>
      <Header title={wodata ? wodata.workOrderCode : `...`} back={URLS.WORK_ORDERS}>
        <Header.Right>
          {[`1`].includes((`` + wodata?.woStatusID)) && (
            <Drawer _ref={addNewAssetRef} onClose={() => { }} outsideClose={false} isAfterOpenRender={true}>
              <Drawer.Button>
                <Button disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)} theme="light">Assign</Button>
              </Drawer.Button>
              <Drawer.Content
                title={`Assign/Schedule`}
                className="!w-[39.563rem]"
              >
                {!getPermissionInfo(location.pathname, "Edit", loggedinuser) ? (
                  <div className="p-4 text-red-500">
                    You don’t have permission to access of this.
                  </div>
                ) : (
                  <ScheduleModalWorkOrder
                    _ref={createSchedulerModalRef}
                    editData={wodata}
                    isAssignonly={true}
                    currentStatus={7}
                    onCreate={() => {
                      addNewAssetRef?.current?.close();
                      window.location.reload();
                    }}
                    onCancel={() => {
                      addNewAssetRef?.current?.close();
                    }}
                  />)}
              </Drawer.Content>
            </Drawer>
          )}
          {[`7`].includes((`` + wodata?.woStatusID)) && (
            <Drawer _ref={addNewAssetRef} onClose={() => { }} outsideClose={false} isAfterOpenRender={true}>
              <Drawer.Button>
                <Button disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)} theme="light">Schedule</Button>
              </Drawer.Button>
              <Drawer.Content
                title={`Assign/Schedule`}
                className="!w-[39.563rem]"
              >
                {!getPermissionInfo(location.pathname, "Edit", loggedinuser) ? (
                  <div className="p-4 text-red-500">
                    You don’t have permission to access this form.
                  </div>
                ) : (<ScheduleModalWorkOrder
                  _ref={createSchedulerModalRef}
                  editData={wodata}
                  isAssignonly={false}
                  currentStatus={2}
                  onCreate={() => {
                    addNewAssetRef?.current?.close();
                    window.location.reload();
                  }}
                  onCancel={() => {
                    addNewAssetRef?.current?.close();
                  }}
                />)}
              </Drawer.Content>
            </Drawer>
          )}
          {[`1`, `2`, `7`].includes((`` + wodata?.woStatusID)) && (
            <>
              <Button disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)} theme="light" onClick={() => {
                if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                  toast.error(`You don't have permission`);
                  return;
                } else {
                  setEditData(wodata);
                  createDrawerRef?.current?.open();
                }
              }}>Edit</Button>
              <Drawer _ref={createDrawerRef} isAfterOpenRender={true} onClose={() => {
                console.log('close drawer', createFacilityRef?.current?.reset);
                createFacilityRef?.current?.reset();
                createFacilityRef?.current?.reset_re_render_vars();
                setEditData(null)
              }} outsideClose={false}>
                <Drawer.Button>{/*<Button>Create New Task</Button>*/}</Drawer.Button>
                <Drawer.Content title={editData ? 'Edit Task' : 'Create New Task'} className='!w-[45rem]'>{/*!w-[39.563rem]*/}
                  {!getPermissionInfo(location.pathname, editData ? "Edit" : "Add", loggedinuser) ? (
                    <div className="p-4 text-red-500">
                      You don’t have permission to access this form.
                    </div>
                  ) : (
                    <CreateWorkOrder _ref={createFacilityRef} editData={editData} onCreate={() => {
                      setEditData(null);
                      getWorkOrderDetails(params.id);
                      createDrawerRef?.current?.close();
                    }} onCancel={() => {

                      setEditData(null);
                      getWorkOrderDetails(params.id);
                      createDrawerRef?.current?.close()
                    }} />)}
                </Drawer.Content>
              </Drawer>
            </>
          )}
          {/*
          <Dropdown>
            
            <Dropdown.Button>
              <Button theme="secondary" className="h-[2.25rem]">
                <Icon name="threedote" size={1.25} className="" />
              </Button>
            </Dropdown.Button>
            <Dropdown.Content
              title="Create New Facility"
              className="!w-[39.563rem]"
            >
              <Menu onClick={() => {}}>Option 1</Menu>
            </Dropdown.Content>
          </Dropdown>
          */}
        </Header.Right>
      </Header>
      {wodata && (
        <div>
          <div className="px-5 border-b border-gray-200 h-[3.75rem] flex items-center gap-[2.188rem] text-gray-600 text-[0.938rem] font-medium relative">
            <button
              className={`hover:text-black relative flex h-full items-center ${tab == "general"
                ? "text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1"
                : ""
                }`}
              onClick={() => setTab("general")}
            >
              General
            </button>
            {/*
            <button
              className={`hover:text-black relative flex h-full items-center ${
                tab == "impactedassets"
                  ? "text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1"
                  : ""
              }`}
              onClick={() => {
                setTab("impactedassets");
              }}
            >
              Impacted Assets
            </button>
            <button
              className={`hover:text-black relative flex h-full items-center ${
                tab == "parts"
                  ? "text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1"
                  : ""
              }`}
              onClick={() => {
                setTab("parts");
              }}
            >
              Parts List
            </button>
            */}
            <button
              className={`hover:text-black relative flex h-full items-center ${tab == "tasks"
                ? "text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1"
                : ""
                }`}
              onClick={() => {
                setTab("tasks");
              }}
            >
              Activity
            </button>
            <button
              className={`hover:text-black relative flex h-full items-center ${tab == "attachment"
                ? "text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1"
                : ""
                }`}
              onClick={() => {
                setTab("attachment");
              }}
            >
              Attachments
            </button>
            <button
              className={`hover:text-black relative flex h-full items-center ${tab == "completion-record" ? "text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1" : ""} ${[1, 7, 2, 4].includes(+wodata.woStatusID) ? "disabled-x" : ""}`}
              onClick={() => {
                setTab("completion-record");
              }}
            >
              Completion Record
            </button>
            {wodata && wodata.woStatusID == 4 && wodata.hasOwnProperty(`originalStartDate`) && wodata.originalStartDate && (
              <div className={`absolute`} style={{ right: `1.1rem`, top: 18 }}><ClockElapseTimer startform={wodata.originalStartDate} /></div>
            )}
          </div>
          <div className="px-5" style={{ maxHeight: `calc(100vh - 120px)`, overflowY: `auto` }}>
            {tab === "general" && <GeneralWOdetails workorder={wodata} onUpdateRequest={() => {
              setShowloader(true);
              setNoWoFound(false);
              setWodata(null);
              getWorkOrderDetails(params.id)
            }} />}
            {/*tab === "impactedassets" && <ImpactedassetsWOdetails workorder={wodata} />*/}
            {/*tab === "parts" && <PartlistWOdetails workorder={wodata} />*/}
            {tab === "tasks" && <TasksWOdetails workorder={wodata} />}
            {tab === "attachment" && <AttachmentWOdetails workorder={wodata} />}
            {tab === "completion-record" && <CompletionrecordWOdetails workorder={wodata} />}
          </div>
        </div>
      )}
      {showloader && !noWoFound && <div style={{ height: `450px`, width: `100%` }} className={`flex items-center justify-center`}><Loader /></div>}

      {/*
            <Header title="Task Details" back={URLS.WORK_ORDERS} />
            <div className="flex flex-col items-center justify-center h-full">
                <h2 className="text-2xl font-bold">Task Details Page</h2>
                <p className="mt-4 text-gray-600">This is a placeholder for Task details.</p>
            </div>
            */}
    </Layout>
  );
};

export default WorkOrderDetails;
